export default __webpack_public_path__ + "static/media/page-found-with-people-connecting-plug-concept-illustration_114360-1927.79036214.jpg";